<template>
  <b-form @submit.prevent="submit">
    <header-page-layout page-title="Logout">
      <b-row class="justify-content-center">
        <b-col col lg="4">
          <b-card class="text-center">
            <p>Are you sure that you would like to logout?</p>
            <b-button variant="danger" @click="logoutClicked">Logout</b-button>
            <b-button variant="outline-secondary" @click="cancel">Cancel</b-button>
          </b-card>
        </b-col>
      </b-row>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'

export default {
  components: {
    HeaderPageLayout
  },

  methods: {
    ...mapActions([
      'logout'
    ]),

    logoutClicked() {
      this.logout()
      this.$router.push({ name: 'login' })
    },

    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>
